import React from "react"

// Simple spinner component to replace FaSpinner
const SpinnerIcon = () => (
  <svg className="animate-spin h-7 w-7" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" className="opacity-25"></circle>
    <path fill="currentColor" className="opacity-75" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
  </svg>
)

type ButtonProps = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
  children: React.ReactNode
  className?: string
  id?: string
  title?: string
  variant?: "primary" | "secondary" | "darkBlue"
  "data-testid"?: string
  type?: "button" | "submit" | "reset"
  loading?: boolean
}

const BaseButton: React.FC<ButtonProps> = ({
  onClick,
  disabled = false,
  children,
  className = "",
  id = "",
  title = "",
  variant = "primary",
  "data-testid": dataTestId = "",
  type = "button",
  loading = false,
}) => {
  const baseClasses =
    "flex flex-row leading-[28px] items-center justify-center py-2.5 px-[18px] rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 text-base font-text-md-semibold"
  const disabledClasses =
    "bg-gray-400 hover:bg-gray-400 text-gray-700 hover:text-gray-700 cursor-not-allowed"
  const activeClasses =
    "transform active:bg-brand-blue-hover active:text-white cursor-pointer"

  const variantClasses = {
    primary:
      "text-white bg-brand-blue hover:bg-brand-blue-hover shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] border border-transparent",
    secondary:
      "text-gray-700 hover:bg-gray-100 bg-base-white shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] border-[1px] border-solid border-gray-300",
    darkBlue:
      "w-full self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-lg bg-brand-blue border-brand-blue border-[1px] border-solid overflow-hidden flex flex-row items-center justify-center py-2.5 px-[18px] text-base text-base-white font-semibold hover:bg-brand-blue-hover",
  }

  const buttonClasses = `${baseClasses} ${variantClasses[variant]} ${
    disabled ? disabledClasses : activeClasses
  } ${className}`
  return (
    <button
      id={id}
      onClick={onClick}
      disabled={disabled || loading}
      className={buttonClasses}
      title={title}
      data-testid={dataTestId}
      type={type}>
      {loading ? (
        <SpinnerIcon />
      ) : (
        children
      )}
    </button>
  )
}

export default BaseButton
